






























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import CreateShareholderRequest from "@/dto/company/CreateShareholderRequest";
import PersonDTO from "@/dto/person/PersonDTO";
import ShareholderDTO from "@/dto/company/ShareholderDTO";
import UpdateShareholderPayload from "@/dto/company/UpdateShareholderPayload";
import {namespace} from "vuex-class";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import CompanyService from "@/services/CompanyService";
import Workspaces from "@/state/Workspaces";

const AppModule = namespace("App");

@Component({
  components: {
  }
})
export default class ShareholderModal extends Vue {
  private successful = false;
  private message = "";
  private request = new CreateShareholderRequest();

  @Prop()
  private onSaved!: () => void

  @Prop()
  private person?: PersonDTO;

  @Prop()
  private shareholder?: ShareholderDTO;

  mounted() {
    if (this.person) {
      this.request.personId = this.person.id;
      this.request.firstName = this.person.firstName;
      this.request.lastName = this.person.lastName;
      this.request.ssn = this.person.ssn;
    }

    if (this.shareholder) {
      this.request.firstName = this.shareholder.person.firstName;
      this.request.lastName = this.shareholder.person.lastName;
      this.request.ssn = this.shareholder.person.ssn;
      this.request.status = this.shareholder.status;
      this.request.share = this.shareholder.share;
      this.request.startDate = this.shareholder.startDate;
      this.request.endDate = this.shareholder.endDate;
    }
  }

  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  maskHandle() {
    let mask = "___-__-____";
    let oldVal = this.request.ssn!.replace(/\D/g, "");

    if (mask.length >= this.request.ssn!.length) {
      this.request.ssn = this.buildPhoneWithMask(mask, oldVal);
    } else if (mask.length < this.request.ssn!.length){
      this.request.ssn = this.request.ssn!.substr(0, mask.length)
    }
  }

  buildPhoneWithMask(mask: string, oldVal: string) {
    let i = 0;

    let newValue = this.deleteSuffixIfNeed(mask.replace(/[_\d]/g, function (a:string) {
      return i < oldVal.length ? oldVal.charAt(i++) : a
    }));

    if (newValue.length <= mask.length) {
      oldVal = newValue;
    }

    if (this.request.ssn!.substr(oldVal.length -1) == "-") {
      newValue = oldVal.substr(0, oldVal.length);
    }

    return newValue;
  }

  deleteSuffixIfNeed(newValue: string) {
    if  (newValue.indexOf("_") != -1) {
      newValue = newValue.substr(0, newValue.indexOf("_"))
    }

    if (newValue.substr(newValue.length - 1) == "-") {
      newValue = newValue.substr(0, newValue.length - 1);
    }

    let suffix = newValue.substr(newValue.length - 2);

    if (suffix == " (" || suffix == ") ") {
      newValue = newValue.substr(0, newValue.length - 2)
    }

    return newValue;
  }

  errorHandle(error: any) {
    this.successful = false;
    this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
    this.stopLoading();
  }


  save() {
    this.message = "";
    this.$validator.validate().then(
        (isValid) => {
          if (isValid) {
            this.startLoading();
            this.request.companyId = Workspaces.getCurrent.id;

            if (this.shareholder) {
                const updatePayload = new UpdateShareholderPayload();
                updatePayload.id = this.shareholder.id;
                updatePayload.status = this.request.status;
                updatePayload.share = this.request.share;
                updatePayload.startDate = this.request.startDate;
                updatePayload.endDate = this.request.endDate;

                CompanyService.updateShareholder(updatePayload).then(
                    suc => {
                        this.successful = true;
                        this.stopLoading();
                        this.$modal.hideAll();
                        this.onSaved();
                    }
                ).catch(error => this.errorHandle(error))
            } else {
                CompanyService.createShareholder(this.request).then(
                    suc => {
                        this.successful = true;
                        this.stopLoading();
                        this.$modal.hideAll();
                        this.onSaved();
                    }
                ).catch(error => this.errorHandle(error))
            }
          }
        }
    )
  }
}
